const mutationTypes = {
    SET_EMPLOYEES: 'SET_EMPLOYEES',
    SET_ERROR: 'SET_ERROR'
};

export { mutationTypes };
